export enum StorageKeys {
  REGISTER_DETAILS = 'register-details',
  SUBTITLES = 'subtitles',
  HOMEPAGE_PLAN_TYPE = 'homepage-plan-type',
}
